import React, { useCallback } from 'react';
import Big from 'big.js';
import { InputNumberButtonWrap, InputNumberButton } from '../../styled';
import { Icon } from '../../../icon';
import { lessThanMax, moreThanMin, getMinusStartValue, getPlusStartValue } from './utils';
export const NumberButtonField = ({ value, step = 1, min, max, onChange, size = 'medium', disabled }) => {
    const handlePlus = useCallback((event) => {
        if (disabled)
            return;
        const startValue = (value && new Big(value)) || getPlusStartValue(step, max, min);
        const calc = startValue.plus(step);
        if (lessThanMax(calc, max)) {
            event.target.value = calc.valueOf();
            onChange(event);
        }
    }, [value, step, max, min, disabled, onChange]);
    const handleMinus = useCallback((event) => {
        if (disabled)
            return;
        const startValue = (value && new Big(value)) || getMinusStartValue(step, max, min);
        const calc = startValue.minus(step);
        if (moreThanMin(calc, min)) {
            event.target.value = calc.valueOf();
            onChange(event);
        }
    }, [value, step, max, min, disabled, onChange]);
    return (React.createElement(InputNumberButtonWrap, null,
        React.createElement(InputNumberButton, { type: "button", disabled: disabled, "$size": size, onClick: handlePlus, "aria-label": "Increment value" },
            React.createElement(Icon, { name: "plus", size: "small" })),
        React.createElement(InputNumberButton, { type: "button", disabled: disabled, "$size": size, onClick: handleMinus, "aria-label": "Decrement value" },
            React.createElement(Icon, { name: "minus", size: "small" }))));
};
